import React from "react";
import { List } from "semantic-ui-react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

const MotivationsForm = ({ values }) => (
	<div>
		{values.motives && values.motives.length > 0 && (
			<>
				<Field
					type="number"
					name="weight_for_motivation"
					customlabel="Poids à prendre en compte pour le calcul des motivations"
					component={CustomInputTextComponent}
				/>
				<List bulleted>
					{values.motives.map((m) => (
						<List.Item key={`k-motiv-${m.id}`}>{m.label}</List.Item>
					))}
				</List>
			</>
		)}
		{values.motives && values.motives.length === 0 && "Pas de motivation"}
	</div>
);

export default MotivationsForm;
